import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZarazeniZakaznik = {
	name: NAME,
	apiProvider,
	router,
};
